/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { logDependencies } from './dependenciesLog.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createLog1p } from '../../factoriesAny.js';
export var log1pDependencies = {
  ComplexDependencies: ComplexDependencies,
  divideScalarDependencies: divideScalarDependencies,
  logDependencies: logDependencies,
  typedDependencies: typedDependencies,
  createLog1p: createLog1p
};